import {
  IDirectPayLinkCreateRequest,
  IDirectPayLinkPublicResponse,
  IDirectPayLinkResponse,
  IDirectPayLinksResponse,
  IDirectPayLinkUpdateRequest,
} from "types/DirectPayLink";

import { api } from ".";

const directPayLinksQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getDirectPayLinksByAccount: builder.query<IDirectPayLinksResponse, string>({
      query: (accountId) => `direct_pay_links?accountId=${accountId}`,
      providesTags: ["DirectPayLinks"],
    }),
    getDirectPayLinkById: builder.query<IDirectPayLinkResponse, string>({
      query: (id) => `direct_pay_links/${id}`,
      providesTags: ["DirectPayLinks"],
    }),
    getDirectPayLinkPublicConfig: builder.query<
      IDirectPayLinkPublicResponse,
      string
    >({
      query: (shortId) => `direct_pay_links/public/${shortId}`,
    }),
    createDirectPayLink: builder.mutation<
      IDirectPayLinkResponse,
      IDirectPayLinkCreateRequest
    >({
      query: (body) => ({
        url: "direct_pay_links",
        method: "POST",
        body,
      }),
      invalidatesTags: ["DirectPayLinks"],
    }),
    updateDirectPayLink: builder.mutation<
      IDirectPayLinkResponse,
      { id: string; data: IDirectPayLinkUpdateRequest }
    >({
      query: ({ id, data }) => ({
        url: `direct_pay_links/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["DirectPayLinks"],
    }),
    deleteDirectPayLink: builder.mutation<{ success: boolean }, string>({
      query: (id) => ({
        url: `direct_pay_links/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["DirectPayLinks"],
    }),
    deactivateDirectPayLink: builder.mutation<
      IDirectPayLinkResponse,
      { id: string; isActive: boolean }
    >({
      query: ({ id, isActive }) => ({
        url: `direct_pay_links/${id}/deactivate`,
        method: "POST",
        body: { isActive },
      }),
      invalidatesTags: ["DirectPayLinks"],
    }),
    calculateDiscountedAmount: builder.mutation<
      {
        success: boolean;
        data: {
          originalAmountInCents: number;
          discountPercentage: number;
          discountedAmountInCents: number;
          finalAmountInCents: number;
        };
      },
      {
        accountId: string;
        amountInCents: number;
        orderType: string;
      }
    >({
      query: (body) => ({
        url: "direct_pay_links/calculate-amount",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetDirectPayLinksByAccountQuery,
  useGetDirectPayLinkByIdQuery,
  useGetDirectPayLinkPublicConfigQuery,
  useCreateDirectPayLinkMutation,
  useUpdateDirectPayLinkMutation,
  useDeleteDirectPayLinkMutation,
  useDeactivateDirectPayLinkMutation,
  useCalculateDiscountedAmountMutation,
} = directPayLinksQueries;
